import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';



@Injectable()
export class OperatingFluidsService {

  private endpointURL = 'operating-fluid/all';
  private endpointURL_new = 'operating-fluid/new';

  constructor(private http: HttpClient) { }

  getAllOperatingFluidManuals(): Observable<any> {
    return this.http.get(this.endpointURL,{withCredentials : true});
  }
  getNewOperatingFluidManuals(): Observable<any> {
    return this.http.get(this.endpointURL_new,{withCredentials : true});
  }
  getUserOperatingFluidHistory(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/operatingFluidHistorylist`,{withCredentials : true});
  }
  addManualToUserHistory(userId, manualId): Observable<any> {
    return this.http.post(`user-info/qID/${userId}/addOperatingFluidToHistorylist/${manualId}`, '',{withCredentials : true});
  }

}
